import { useEffect, useState } from 'react';
import 'intro.js/introjs.css'; // Import the CSS
import TileList from '../../../components/tile-list';
import introJs from 'intro.js';
import { connect } from 'react-redux';
import { deleteApp, getAllApps, importApp } from '../../../services/app/app-service';
import PageContainer from "../../../components/page-container";
import AppSaveDialog from "../agent-save-modal";
import ConfirmDialog from "../../../components/confirm-dialog/confirm-dialog";
import AppTemplateSelector from "../agent-template-selector";
import TemplateCardList from "../../../components/template-card-list";
import { HiOutlinePlus, HiOutlineSquares2X2, HiOutlineSparkles } from 'react-icons/hi2';
import ProgressDialog, { PROGRESS_STATUS } from '../../../components/progress-dialog/progress-dialog';

const mapsStateToProps = (state, ownProps) => {
  return {
    appCreateNotifyMessage: state.appCreateNotifyMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

export function ApplicationsList({ appCreateNotifyMessage }) {
  const [apps, setApps] = useState([]);
  const [openCreateApp, setOpenCreateApp] = useState(false);
  const [formState, setFormState] = useState({
    processing: false,
    success: false,
    failed: false,
    errorMessage: ''
  });

  const hasAssistants = apps.length > 0;

  const WelcomeMessage = () => (
    <div className="flex items-center justify-center py-8">
      <div className="mt-6 flex flex-col items-center gap-3 rounded-xl border border-dashed border-gray-200 bg-gray-50/60 px-8 py-16 text-center md:w-2/3 lg:w-1/2">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-lime/20">
          <HiOutlineSparkles className="h-7 w-7 text-primary" />
        </div>
        <h2 className="text-2xl font-semibold tracking-tight text-gray-900">
          Welcome to BotCircuits!
        </h2>
        <p className="max-w-md text-sm text-gray-500">
          Let's get you started with creating your first AI Application.
        </p>
      </div>
    </div>
  );

  const [deletingData, setDeletingData] = useState(false);
  const [openDeleteConfirmDialog, setDeleteRevokeConfirmDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [importingData, setImportingData] = useState(null);
  const [openImportConfirmDialog, setOpenImportConfirmDialog] = useState(false);
  const [importDialog, setImportDialog] = useState({ open: false, status: PROGRESS_STATUS.PROCESSING, error: '' });


  async function fetchApps() {
    updateFormState(true, false, false);
    setApps(await getAllApps());
    updateFormState(false, false, false);
    setDataFetched(true);
  }
  const handleDelete = (appId) => {
    setDeletingData(appId)
  };

  const handleExport = (appId, success) => {
    if (success) {
      console.log(`Successfully exported app: ${appId}`);
    } else {
      console.error(`Failed to export app: ${appId}`);
    }
  };

  const handleImportRequest = (appId, appName, configData) => {
    setImportingData({ appId, appName, configData });
    setOpenImportConfirmDialog(true);
  };

  const handleImportConfirm = async (confirmed) => {
    setOpenImportConfirmDialog(false);

    if (confirmed && importingData) {
      setImportDialog({ open: true, status: PROGRESS_STATUS.PROCESSING, error: '' });
      try {
        const { status } = await importApp(importingData.appId, importingData.configData);
        if (status === 200) {
          setImportDialog({ open: true, status: PROGRESS_STATUS.SUCCESS, error: '' });
          await fetchApps();
        } else {
          setImportDialog({ open: true, status: PROGRESS_STATUS.ERROR, error: 'Import failed. Please check the file format.' });
        }
      } catch (error) {
        console.error('Import error:', error);
        setImportDialog({ open: true, status: PROGRESS_STATUS.ERROR, error: 'Import failed. Please try again.' });
      }
    }

    setImportingData(null);
  };

  const handleImportDialogClose = () => {
    setImportDialog((prev) => ({ ...prev, open: false }));
  };

  async function deleteStore(status) {
    if (status) {
      updateFormState(true, false, false);
      await deleteApp(deletingData)
      updateFormState(false, false, false);
      await fetchApps();
      setDeletingData()
    }
    setDeleteRevokeConfirmDialog(false);
  }

  useEffect(() => {
    fetchApps();
  }, []);

  useEffect(() => {
    fetchApps();
  }, [appCreateNotifyMessage]);

  useEffect(() => {
    if (deletingData) {
      setDeleteRevokeConfirmDialog(true);
    }
  }, [deletingData]);

  const handleOpenCreateApp = () => {
    setSelectedTemplate(null);
    setOpenCreateApp(true);
  }

  const handleOnCompletionCreateApp = () => {
    setOpenCreateApp(false);
  }

  const updateFormState = (processing, success, failed, errorMessage) => {
    setFormState(Object.assign({}, { processing, success, failed, errorMessage }))
  }

  const processDataList = apps.map(dt => {
    return {
      record: dt
    }
  })

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openTemplateSelector, setOpenTemplateSelector] = useState(false);
  const handleOnOpenTemplateSelector = () => {
    setOpenTemplateSelector(true);
  }

  const handleOnCompleteTemplateSelector = template => {
    setOpenTemplateSelector(false);
    if (template) {
      setSelectedTemplate({ ...template })
    }
  }

  // useEffect(() => {
  //   if (dataFetched && !hasAssistants) {
  //     const intro = introJs();
  //     intro.setOptions({
  //       steps: [
  //         {
  //           element: '#new-assistant-btn',
  //           intro: 'Click here to create your first Assistant.',
  //           position: 'bottom'
  //         },
  //         {
  //           element: '#assistant-library-btn',
  //           intro: 'Or select an Assistant from the library.',
  //           position: 'bottom'
  //         }
  //       ],
  //       exitOnOverlayClick: false,
  //       showBullets: false
  //     });
  //     intro.start();
  //   }
  // }, [hasAssistants, dataFetched]);

  function showBody() {
    if (dataFetched && hasAssistants) {
      return <TileList tiles={processDataList} onDelete={handleDelete} onClickCreate={handleOpenCreateApp} onExport={handleExport} onImportRequest={handleImportRequest} />

    } else if (dataFetched && !hasAssistants) {
      return (
        <div>
          <WelcomeMessage />
        </div>
      )
    }
  }

  useEffect(() => {
    if (selectedTemplate) {
      setOpenCreateApp(true);
    }
  }, [selectedTemplate]);

  return (
    <PageContainer title="My Applications"
      subtitle="Create and manage your AI agents"
      headerAction={
        <div className="flex flex-row items-center gap-2">
          {/* <button
            type="button"
            onClick={handleOnOpenTemplateSelector}
            id="assistant-library-btn"
            className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 text-sm font-medium text-gray-700 transition-all duration-200 hover:border-gray-300 hover:bg-gray-50 active:scale-[0.97] dark:bg-transparent"
          >
            <HiOutlineSquares2X2 className="h-4 w-4" />
            Start with a template
          </button> */}
          <button
            type="button"
            onClick={handleOpenCreateApp}
            id="new-assistant-btn"
            className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-primary px-4 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-secondary hover:shadow-md active:scale-[0.97]"
          >
            <HiOutlinePlus className="h-4 w-4" />
            New Application
          </button>
        </div>
      }
    >

      {openCreateApp && (
        <AppSaveDialog
          onCompletion={handleOnCompletionCreateApp}
          onCancel={handleOnCompletionCreateApp}
          selectedTemplateProp={selectedTemplate}
        />
      )}

      {openDeleteConfirmDialog && (
        <ConfirmDialog
          appId={deletingData}
          open={openDeleteConfirmDialog}
          onCompletion={deleteStore}
          title="Delete Confirmation"
          message="Are you sure you want to delete this Application?"
        />
      )}

      {openImportConfirmDialog && importingData && (
        <ConfirmDialog
          open={openImportConfirmDialog}
          onCompletion={handleImportConfirm}
          title="Import Confirmation"
          message={`Are you sure you want to import configuration into "${importingData.appName}"? This will overwrite existing configurations.`}
        />
      )}

      {openTemplateSelector && (
        <AppTemplateSelector onCompletion={handleOnCompleteTemplateSelector} />
      )}

      <ProgressDialog
        open={importDialog.open}
        status={importDialog.status}
        title="Importing Configuration"
        processingMessage="Importing configuration, please wait..."
        successMessage="Configuration imported successfully!"
        errorMessage={importDialog.error || 'Import failed. Please try again.'}
        onCancel={handleImportDialogClose}
        onClose={handleImportDialogClose}
      />

      {formState.processing && (
        <TemplateCardList />
      )}
      {showBody()}
    </PageContainer>

  )
}

export default connect(mapsStateToProps, mapDispatchToProps)(ApplicationsList)
